import { RootState } from "@/redux/store";

export const networkSelector = (state: RootState) => state.network.items;
export const networkPageSelector = (state: RootState) => state.network.page;
export const networkHistorySelector = (state: RootState) => state.network.history.items;
export const networkHistoryPageSelector = (state: RootState) => state.network.history.page;
export const networkFleetLeaderItemsSelector = (state: RootState) => state.network.fleetLeader.items;
export const networkFleetLeaderPageSelector = (state: RootState) => state.network.fleetLeader.page;
